export enum TableCellAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}
